import React, { useState, useEffect } from 'react';
import '../styles/HeroSection.css';
import p1 from '../assets/pest.png';
import p2 from '../assets/bed.png';
import p3 from '../assets/term.png';
import p4 from '../assets/ant.png';
import p5 from '../assets/cock.png';

const HeroSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  // Array of 7 images with mixed content
  const slides = [
    {
      id: 1,
      image: p1,
      alt: 'Professional pest control technician in protective gear',
      title: 'Expert Pest Control Services',
      subtitle: 'Professional technicians ready to protect your home',
      overlay: 'dark'
    },
    {
      id: 2,
      image: p3,
      alt: 'Termite damage inspection',
      title: 'Termite Treatment Specialists',
      subtitle: 'Protect your property from costly termite damage',
      overlay: 'dark'
    },
    {
      id: 3,
      image: p4,
      alt: 'Ant infestation control',
      title: 'Ant & Cockroach Extermination',
      subtitle: 'Fast and effective elimination of common household pests',
      overlay: 'dark'
    },
    {
      id: 4,
      image: p2,
      alt: 'Bed bug treatment',
      title: 'Bed Bug Removal Experts',
      subtitle: 'Heat and chemical treatments for complete eradication',
      overlay: 'dark'
    },
    {
      id: 5,
      image: p5,
      alt: 'Rodent control and removal',
      title: 'Rodent Removal & Prevention',
      subtitle: 'Humane and effective solutions for mice and rats',
      overlay: 'dark'
    },
    {
      id: 6,
      image: p3,
      alt: 'Eco-friendly pest control',
      title: 'Eco-Friendly Solutions',
      subtitle: 'Safe for your family, pets, and the environment',
      overlay: 'dark'
    },
    {
      id: 7,
      image: p2,
      alt: 'Happy customer after pest control service',
      title: '100% Satisfaction Guaranteed',
      subtitle: 'Join thousands of happy customers across the USA',
      overlay: 'dark'
    }
  ];

  // Auto-slide every 5 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [slides.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const handleCallNow = () => {
    window.location.href = 'tel:+18334936242';
  };

  const handleBookNow = () => {
    window.location.href = 'tel:+18334936242';
  };

  return (
    <section className="hero-section" id="hero">
      <div className="hero-slider">
        {slides.map((slide, index) => (
          <div
            key={slide.id}
            className={`hero-slide ${index === currentSlide ? 'active' : ''}`}
          >
            <div className="hero-image-wrapper">
              <img
                src={slide.image}
                alt={slide.alt}
                className="hero-image"
                loading={index === 0 ? 'eager' : 'lazy'}
              />
              <div className={`hero-overlay ${slide.overlay}`}></div>
            </div>
            
            <div className="hero-content">
              <div className="hero-content-inner">
                <div className="hero-badge">🐜 PestControl Today</div>
                <h1 className="hero-title">{slide.title}</h1>
                <p className="hero-subtitle">{slide.subtitle}</p>
                
                <div className="hero-cta-group">
                  <button className="btn-hero-primary" onClick={handleBookNow}>
                    📅 Book Online Now
                  </button>
                  <button className="btn-hero-secondary" onClick={handleCallNow}>
                    📞 Call +1 (833) 493-6242
                  </button>
                </div>

                <div className="hero-stats">
                  <div className="hero-stat">
                    <span className="stat-number">15,000+</span>
                    <span className="stat-label">Happy Customers</span>
                  </div>
                  <div className="hero-stat">
                    <span className="stat-number">99%</span>
                    <span className="stat-label">Success Rate</span>
                  </div>
                  <div className="hero-stat">
                    <span className="stat-number">4.9★</span>
                    <span className="stat-label">Google Reviews</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Navigation Arrows */}
      <button className="slider-arrow prev" onClick={prevSlide} aria-label="Previous slide">
        ❮
      </button>
      <button className="slider-arrow next" onClick={nextSlide} aria-label="Next slide">
        ❯
      </button>

      {/* Slide Indicators */}
      <div className="slider-indicators">
        {slides.map((_, index) => (
          <button
            key={index}
            className={`indicator-dot ${index === currentSlide ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </section>
  );
};

export default HeroSection;